import { render, staticRenderFns } from "./alerts.vue?vue&type=template&id=66be25e4&scoped=true"
import script from "./alerts.vue?vue&type=script&lang=ts"
export * from "./alerts.vue?vue&type=script&lang=ts"
import style0 from "./alerts.vue?vue&type=style&index=0&id=66be25e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66be25e4",
  null
  
)

export default component.exports